import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";

export const ConfirmDialog = ({ open, onOpenChange, title, description, confirmLabel = "Confirm", onConfirm, destructive = false }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="confirm-dialog">
      <DialogHeader>
        <DialogTitle className="font-extrabold uppercase">{title}</DialogTitle>
        <DialogDescription>{description}</DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <Button variant="outline" data-testid="confirm-dialog-cancel" onClick={() => onOpenChange(false)} className="rounded-full font-bold">
          Cancel
        </Button>
        <Button
          data-testid="confirm-dialog-confirm"
          onClick={() => {
            onConfirm();
            onOpenChange(false);
          }}
          className={`rounded-full font-bold text-clean-white ${destructive ? "bg-red-600 hover:bg-red-700" : "bg-stranger-orange hover:bg-orange-600"}`}
        >
          {confirmLabel}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
